<template>
  <div class="bg-background-neutral-secondary rounded-2xl p-4">
    <ApplyPromocodeShimmer v-if="isRefetching" />
    <AppliedPromocode
      v-else-if="activePromocodeModifier"
      :order-id="orderId"
      :promocode-modifier="activePromocodeModifier"
    />
    <UnappliedPromocode
      v-show="!isRefetching && !activePromocodeModifier"
      :order-id="orderId"
      :bill-id="billId"
      :has-active-promocode="Boolean(activePromocodeModifier)"
      :bookings="bookings"
      :flights="flights"
      @onAutomaticApply="emit('onAutomaticApply')"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import type { Airflow } from '@aviata/platform-types';
  import type { flightEntity } from 'freedom-shared';

  import { useOrderQuery, getActivePromocodeModifier } from '@/entities/order';

  import UnappliedPromocode from './UnappliedPromocode.vue';
  import ApplyPromocodeShimmer from './ApplyPromocodeShimmer.vue';
  import AppliedPromocode from './AppliedPromocode.vue';

  const props = defineProps<{
    orderId: string;
    billId: string;
    flights: flightEntity.types.MappedFlight[];
    bookings: Airflow.Product.BookingData[];
  }>();
  const emit = defineEmits<{ onAutomaticApply: [] }>();

  const orderQuery = useOrderQuery(props.orderId);

  const isRefetching = computed(
    () => orderQuery.isSuccess.value && orderQuery.isFetching.value,
  );

  const activePromocodeModifier = computed(() => {
    if (!orderQuery.data.value) {
      return;
    }

    return getActivePromocodeModifier(orderQuery.data.value, props.billId);
  });
</script>
